import { useMemo } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import cn from 'classnames'

import style from '@src/pages/RecoveryPassword/RecoveryPassword.module.scss'
import { Button } from '@src/components/Button/Button'
import { validateForm } from '@src/messages/validateForm'
import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
import { recoveryPasswordSecondStep } from '@src/store/ducks/auth/thunks'
import { AppDispatch } from '@src/store/store'

export const RecoveryPasswordSecondForm = () => {
  const dispatch = useDispatch<AppDispatch>()

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      password: Yup.string().required(validateForm.required),
      confirmPassword: Yup.string().required(validateForm.required)
        .oneOf([Yup.ref('password'), null], 'Пароли не совпадают')
        .min(8, 'Минимальная длина строки 8 символов'),
    })
  ), [])

  const initialValues = useMemo(() => ({
    password: '',
    confirmPassword: '',
  }), [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={({ password }) => {
        dispatch(recoveryPasswordSecondStep(password))
      }}
      validationSchema={validationSchema}
    >
      {() => (
        <Form>
          <div>
            <FieldFormik
              name="password"
              type="password"
              placeholder="Пароль"
            />
            <FieldFormik
              name="confirmPassword"
              type="password"
              placeholder="Повторите пароль"
            />
          </div>
          <div className={cn(style.btnBlock, style.second)}>
            <Button
              htmlType="submit"
              type="secondary"
              className={style.btnSize}
            >
              Отправить
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}
